module.exports = __webpack_public_path__ + "static/media/drow_ranger.aa7945de.png";